// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1nu5M","resendInfoText":"OnGoingPaymentBox_resendInfoText__1YxsQ"};